import React from "react";
import { toast } from "react-toastify";

import { useCountryDetailContext } from "contexts/CountryDetailContext";

import EnableDisableButton from "components/Shared/EnableDisableButton";

import { useUpdateCountryMutation } from "store/services/countryApi";

export const ToggleCountryStatus = () => {
  const { countryDetail } = useCountryDetailContext();

  // RTK Query
  const [updateCountry, { isLoading: updatingCountry }] =
    useUpdateCountryMutation();

  // methods
  const handleUpdateStatus = async () => {
    try {
      await updateCountry({
        _id: countryDetail?._id,
        isActive: !countryDetail?.isActive,
      }).unwrap();

      toast.info(
        `Country successfully ${
          countryDetail?.isActive ? "Disabled" : "Enabled"
        }!`
      );
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update Country's Status!");
    }
  };

  if (!countryDetail) return null;

  return (
    <EnableDisableButton
      suffix="Country Detail"
      isActive={countryDetail?.isActive}
      loading={updatingCountry}
      onClick={handleUpdateStatus}
    />
  );
};
